<div style="height: 100%">
	            <div class="mat-elevation-z2 control-strip" style="padding-bottom:0;">
                <TABLE style="padding-top:2px;width: 100%;border-spacing:0;border-collapse:collapse;"> <TR style="width:100%;">
                    <TD>
                    <button *ngIf="visibleMatch" mat-button
                            [disabled]="isEditing || selectedRecord?.recordStatus === 0"
                            class="command-button command-button-override"
                            matTooltipPosition="below"
                            matTooltip="Assign this request to an agency"
                            (click)="doMatch()" mat-button>
                        <mat-icon class="command-icon-style">assignment</mat-icon>
                        Assign
                    </button>

                <button *ngIf="visibleApprove" mat-button
                        class="command-button command-button-override"
                        matTooltipPosition="below"
                        [disabled]="isEditing || selectedRecord?.recordStatus === 0 ||
                        selectedRecord?.requestStatusId < 2"
                        matTooltip="Approve this request" (click)="doApprove()"
                        mat-button>
                    <mat-icon class="command-icon-style">thumb_up</mat-icon>
                    Approve
                </button>

                <button *ngIf="visibleStatus" mat-button
                        class="command-button command-button-override"
                        matTooltipPosition="below"
                        [disabled]="isEditing || selectedRecord?.recordStatus === 0"
                        matTooltip="Deny or cancel the request" (click)="doStatus()"
                        mat-button>
                    <mat-icon class="command-icon-style">thumb_down</mat-icon>
                    Deny
                </button>

                <button *ngIf="visibleCollaborate" mat-button
                        class="command-button command-button-override"
                        matTooltipPosition="below"
                        [disabled]="isEditing || selectedRecord?.recordStatus === 0 ||
                        selectedRecord?.requestStatusId < 2"
                        matTooltip="Request/answer a collaboration" (click)="doApprove()"
                        mat-button>
                    <mat-icon class="command-icon-style">share</mat-icon>
                    Collaborate
                </button>
                <TD width="20%" style="text-align: right; padding: 0;">
                    <button *ngIf="visibleClericalOpen && selectedRecord?.recordStatus === 0" mat-button
                            class="command-button command-button-override" style="width: 145px;"
                            matTooltipPosition="below"
                            matTooltip="Re-open this request for clerical reasons"
                            (click)="doReOpenRequest()" mat-button>
                        <mat-icon class="command-icon-style">restore</mat-icon>
                        Clerical Open
                    </button>
                    <div *ngIf="selectedRecord?.clericalOpen === 1"
                         style="display: inline-flex; align-items: center;
                                background-color: #2dde5e; color: black;
                                padding: 5px 16px; border-radius: 0;
                                font-weight: bold; font-size: 12px;
                                height: 38px; box-sizing: border-box;"
                         matTooltip="Note: you are editing a record for this request only - it will not be reflected in other related requests and cases"
                         matTooltipPosition="below">
                        <mat-icon style="font-size: 15px; height: 15px; width: 15px; margin-right: 6px; line-height: 15px;">history_edu</mat-icon>
                        History Edit Mode
                    </div>
                </TD>
        </TR>
        </TABLE>

      </div>
 <div class="dwform" style="padding-right: 15px;height: 100%;margin-top: -4px;">

	   <div class="dwform-cell-nopadding right-border"
		   style="min-width:400px;width: 33%;padding-left: 9px;padding-top: 13px;"> <!--LHS Fields -->
			<div style="display: inline-block; width: 100%; text-align: right;padding-right: 12px;padding-top:1px;">
					  <button mat-button *ngIf="visibleEdit" class="command-button"
                              [disabled] = "_caseId<1 || isEditing ||  selectedRecord?.recordStatus === 0"
						(click)="editRecord()" matTooltip="Edit the record"
						mat-button>
					<mat-icon>edit</mat-icon>
					Edit
				</button>
			</div>
			<div class="dwform-row">
				<label class="label-field">Request Id:</label>
				<span class="form-required"></span>
				{{valRequestId}}

			</div>
			<div class="dwform-row-gap"></div>
			<div class="dwform-row-gap"></div>
			<div class="dwform-row">
					<label class="label-field">Request Type:</label>
					<span class="form-required">*</span>
					
                <dw-dropdown
                         id="serviceTypeId"
                         [disabled]="!(isEditing && visibleEdit)"
                         [(selectedItem)]="selectedServiceRequestTypeId"
                         (itemSelected)="selectedServiceRequestTypeId = $event; setServiceType();presetServiceDefsList();"
                         [dataSource]="serviceRequestTypes"
                         [controlWidth]="'240px'" >
                 </dw-dropdown>
					
			</div>
			<div class="dwform-row-gap"></div>
			<div class="dwform-row-gap"></div>

			<div class="dwform-row">
				<label class="label-field">Agency Service:</label><span class="form-required"></span>
				 <dw-dropdown
                         id="serviceDefId"
                         [disabled]="!isEditing"
                         [(selectedItem)]="selectedServiceDefId"
                         (itemSelected)="selectedServiceDefId = $event; setServiceDef();"
                         [dataSource]="serviceDefs"
                         [controlWidth]="'240px'" >
                 </dw-dropdown>
			</div>

           <div class="dwform-row-gap"></div>
           <div class="dwform-row-gap"></div>
           <label class="label-field">Service Start Date:</label>
           <span class="form-required">*</span>

           <input class="input-field-short" style="width:80px;"
                  [disabled]="!isEditing"
                  id="startDateId"
                  mask="9999-99-99" [dropSpecialCharacters]="false"
                  showMaskTyped="true"
                  [(ngModel)]="startDate"
                  placeholder="<Start date>" type="text"/>
           <div style="display: inline-block; width: 30px;"></div>
           <label class="label-field-half" style="width:30px;">To:</label>
           <span class="form-required">*</span>

           <input class="input-field-short" style="width:80px;"
                  id="endDateId"
                  [disabled]="!isEditing"
                  mask="9999-99-99" [dropSpecialCharacters]="false"
                  showMaskTyped="true"
                  [(ngModel)]="endDate"
                  placeholder="<End date>" type="text"/>

			<div class="dwform-row-gap"></div>
		   <div class="dwform-row-gap"></div>
			<div class="dwform-row">
					<label class="label-field">Amount requested:</label>
					<span class="form-required"></span>
					<input class="input-field" id="amount"
						   style="width: 140px;text-transform: capitalize"
						   [(ngModel)]="valAmountRequested" [disabled] = "!isEditing"
						   placeholder="<Amount/Quantity>"
						   type="text">

			<div class="dwform-row-gap"></div>
			<div class="dwform-row-gap"></div>
			
			<label class="label-field">Unit of Measure:</label>
					<span class="form-required">*</span>
					 <dw-dropdown
                                [disabled]="!isEditing"
                                [controlWidth]="'180px'"
                                [dataSource]="uomList"
                                (itemSelected)="unitOfMeasure = $event"
                                [controlWidth]="'240px'"
                                [selectedItem]="unitOfMeasure">
                     </dw-dropdown>
            <div class="dwform-row-gap"></div>
			<div class="dwform-row-gap"></div>
			        
			<label class="label-field">Prevent Auto-close:</label>
					<span class="form-required"></span>
					  <mat-checkbox [(ngModel)]="keepOpen" binary="true" [disabled]="!isEditing"  matTooltipPosition="below"
                            matTooltip="Keep this request open even if the time has lapsed and the due date is missed"></mat-checkbox>
			<div class="dwform-row-gap"></div>
			<div class="dwform-row-gap"></div>
		</div>
	  </div>
	  
	    <div class="dwform-cell-nopadding right-border"
		   style="min-width:360px;width: 25%;padding-left: 0px;padding-top: 4px;"> <!--Middle section- For Members mapping -->
			
			   <div class="mat-elevation-z1 case-mapping-table-div" >
			   <table mat-table [dataSource]="dataSource" class="case-mapping-table-properties" style="width: 100%;padding-top: 0px;padding-right: 0px;padding-left: 0px;">

                    <ng-container matColumnDef="select">
		                <th mat-header-cell *matHeaderCellDef 
		                    class="mat-table-header-style mat-table-header-override" style="width: 5px;text-align: left;background: #bfbfbf;">
		                    <mat-checkbox (click)="$event.stopPropagation()" [disabled] = "!isEditing"
		                                  [(ngModel)]="headerSelect"
		                                  (change)="toggleAllSelected($event)" style="margin-right:10px;margin-left: -15px;"></mat-checkbox>
		                </th>
		                <td mat-cell *matCellDef="let element;let tableRowIdx = index;"
		                    style="width:5px !important;">
		                    <mat-checkbox (click)="$event.stopPropagation();" [disabled] = "!isEditing"
		                                  (change)="runChecked($event, element)" style="margin-right:10px;margin-left: -15px;"
		                                  [value]="element.select" [(ngModel)]="element.select" >
		                    </mat-checkbox>
		                </td>
		            </ng-container>

                        
                           <ng-container matColumnDef="member">
                            <th mat-header-cell class="mat-table-header-style mat-table-header-override" style="width: 180px;text-align: left;background: #bfbfbf;"
                                *matHeaderCellDef> Member
                            </th>
                            <td mat-cell *matCellDef="let element" style="width: 180px;text-align: left;"
                                class="table-row-class">
                            <span [ngStyle]="{'font-weight': element.primaryApplicantFlag === 1 ? 'bold' : 'normal'}">{{element.member}}</span>
                            </td>
                          </ng-container>
                            <ng-container matColumnDef="relationship">
                                <th mat-header-cell class="mat-table-header-style mat-table-header-override" style="background: #bfbfbf;"
                                    *matHeaderCellDef> Relationship
                                </th>
                                <td mat-cell *matCellDef="let element" style="padding-left: 5px;"
                                    class="table-row-class">
                                    <span>{{element.relationship}}</span>
                                </td>
                            </ng-container>

                      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                      <tr mat-row
                            *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                            [ngClass]="{'row-selected': tableRowIdx == Idx}">
                          </tr>
             </table>
             </div>
             
             <div class="mat-elevation-z1 adv-mapping-table-div" >
			   <table mat-table [dataSource]="dataSourceAdv" class="adv-mapping-table-properties" style="width: 100%;padding-top: 0px;padding-right: 0px;padding-left: 0px;">

                    <ng-container matColumnDef="select">
		                <th mat-header-cell *matHeaderCellDef 
		                    class="mat-table-header-style mat-table-header-override" style="width: 5px;text-align: left;background: #bfbfbf;">
		                </th>
		                <td mat-cell *matCellDef="let element;let tableRowIdx = index;"
		                    style="width:5px !important;">
		                    <mat-checkbox (click)="$event.stopPropagation();" [disabled] = "!isEditing"
		                                  (change)="runCheckedAdv($event, element)" style="margin-right:10px;margin-left: -15px;"
		                                  [value]="element.select" [(ngModel)]="element.select" >
		                    </mat-checkbox>
		                </td>
		            </ng-container>

                           <ng-container matColumnDef="member">
                            <th mat-header-cell class="mat-table-header-style mat-table-header-override" style="width: 180px;text-align: left;background: #bfbfbf;"
                                *matHeaderCellDef> Advocate
                            </th>
                            <td mat-cell *matCellDef="let element" style="width: 180px;text-align: left;"
                                class="table-row-class">
                            <span [ngStyle]="{'font-weight': element.primaryApplicantFlag === 1 ? 'bold' : 'normal'}">{{element.member}}</span>
                            </td>
                          </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                      <tr mat-row
                            *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                            [ngClass]="{'row-selected': tableRowIdx == Idx}">
                          </tr>
             </table>
             </div>

		</div>
	 <app-req-summary #reqSummary
                      [requestSummary]="requestSummary"
        [requestStatusId]="selectedRecord?.requestStatusId"
        [serviceRequestId]="selectedRecord?.id"></app-req-summary>
	<!----------------------->
	<!-- ERROR LINE --------->
	<!----------------------->
	<div class="error-line" [hidden]='!strErr.length'
		 style="text-align:left;bottom: 40px;">{{strErr}}</div>
	<!----------------------->
	<!-- SAVE STRIP        -->
	<!----------------------->
	<div class="save-close-strip request-footer" style="width: 100%;height:39px; bottom: 3px;background-color: #E1E1E1;" *ngIf="isEditing">

		<button mat-button class="command-button" style="margin-top: 3px;"
				(click)="submitRecord()" matTooltip="Save the record"
				mat-button>
			<mat-icon>check_circle_outline</mat-icon>
			Submit
		</button>
		<button mat-button class="command-button" style="margin-top: 3px;"
				(click)="cancelSubmitRecord()" matTooltip="Cancel edits" mat-button>
			<mat-icon>highlight_off</mat-icon>
			Cancel
		</button>
	</div>
</div>
</div>

<p-dialog header="Assign to Agency" [focusOnShow]="false"
          [(visible)]="matchAgencyDlg" [modal]="true"
          [style]="{width: '650px', height: '580px'}"
          appendTo="body" [closeOnEscape]="false"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-match #matchAgency
          [serviceRequest]="selectedRecord"
          (submitClicked)="submitMatchRequest($event);"
          (cancelClicked)="matchAgencyDlg=false"></app-match>
</p-dialog>

<p-dialog
          header="{{dialogHeaderText}}" [focusOnShow]="true"
          [(visible)]="approveRequestDlg" [modal]="true"
          [style]="{width: '800px', height: '690px'}"
          appendTo="body"
           [minY]="35" [resizable]="false" [closable]="false" >
        <app-approverequest #approveRequest
            [serviceRequest]="selectedRecord"
            (submitClicked)="approveRequestSubmitted($event)"
            (cancelClicked)="approveRequestDlg=false">
        </app-approverequest>
</p-dialog>

<p-dialog header="Assign Status" [focusOnShow]="false"
          [(visible)]="assignStatusDlg" [modal]="true"
          [style]="{width: '520px'}"
          appendTo="body" [closeOnEscape]="false"
          [minY]="35" [resizable]="false" [closable]="true" >
    <app-req-status [requestStatusList]="requestStatuses" #assignStatus
                    [(serviceRequest)]="selectedRecord"
        (cancelClicked)="assignStatusDlg=false"
        (submitClicked)="assignStatusDlg=false;doAssignStatusSubmitted($event)">
    </app-req-status>
</p-dialog>
